import { createAction, props } from '@ngrx/store';
import { ErrorsNestedFormGroup } from './types';
import { ProblemDetails } from '../../error/types';

export const formActions = {
  setIsDirty: createAction(
    '[Form] set IsDirty',
    props<{ formName: string; isDirty: boolean }>(),
  ),
  clear: createAction('[Form] clear'),
  countErrors: createAction(
    '[Form] count Errors',
    props<ErrorsNestedFormGroup>(),
  ),
  setErrorsEntity: createAction(
    '[Form] set Entity',
    props<{ entityType: string }>(),
  ),
  transformToErrors: createAction(
    '[Form] transform to Errors',
    props<{ problemDetails: ProblemDetails }>(),
  ),
};
export type FormAction = typeof formActions;
